$(function () {
    $('#show_sidebar').on('click', function () {
        $('#sidebar').addClass('sidebar_show');
    });

    $('#sidebar_close').on('click', function () {
        $('#sidebar').removeClass('sidebar_show');
    })
})